require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _color = _interopRequireDefault(require("color"));

var _colors = require("../styles/colors");

var _theming = require("../core/theming");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/Badge.tsx";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var defaultSize = 20;

var Badge = function (_React$Component) {
  (0, _inherits2["default"])(Badge, _React$Component);

  function Badge() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Badge);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Badge)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      opacity: new _reactNative.Animated.Value(_this.props.visible ? 1 : 0)
    });
    return _this;
  }

  (0, _createClass2["default"])(Badge, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          visible = _this$props.visible,
          scale = _this$props.theme.animation.scale;

      if (visible !== prevProps.visible) {
        _reactNative.Animated.timing(this.state.opacity, {
          toValue: visible ? 1 : 0,
          duration: 150 * scale,
          useNativeDriver: true
        }).start();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          _this$props2$size = _this$props2.size,
          size = _this$props2$size === void 0 ? defaultSize : _this$props2$size,
          style = _this$props2.style,
          theme = _this$props2.theme,
          visible = _this$props2.visible,
          rest = (0, _objectWithoutProperties2["default"])(_this$props2, ["children", "size", "style", "theme", "visible"]);
      var opacity = this.state.opacity;

      var _ref = _reactNative.StyleSheet.flatten(style) || {},
          _ref$backgroundColor = _ref.backgroundColor,
          backgroundColor = _ref$backgroundColor === void 0 ? theme.colors.notification : _ref$backgroundColor,
          restStyle = (0, _objectWithoutProperties2["default"])(_ref, ["backgroundColor"]);

      var textColor = (0, _color["default"])(backgroundColor).isLight() ? _colors.black : _colors.white;
      var borderRadius = size / 2;
      return React.createElement(_reactNative.Animated.Text, (0, _extends2["default"])({
        numberOfLines: 1,
        style: [_objectSpread({
          opacity: opacity,
          backgroundColor: backgroundColor,
          color: textColor,
          fontSize: size * 0.5
        }, theme.fonts.regular, {
          lineHeight: size,
          height: size,
          minWidth: size,
          borderRadius: borderRadius
        }), styles.container, restStyle]
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 108
        }
      }), children);
    }
  }]);
  return Badge;
}(React.Component);

(0, _defineProperty2["default"])(Badge, "defaultProps", {
  visible: true,
  size: defaultSize
});

var _default = (0, _theming.withTheme)(Badge);

exports["default"] = _default;

var styles = _reactNative.StyleSheet.create({
  container: {
    alignSelf: 'flex-end',
    textAlign: 'center',
    textAlignVertical: 'center',
    paddingHorizontal: 4,
    overflow: 'hidden'
  }
});